<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { X } from '@lucide/vue'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import NotificationContent from '@/features/notifications/components/NotificationContent.vue'
import type { Notification } from '@/features/notifications/types/notification'

defineProps<{ notification: Notification }>()

const emit = defineEmits<{
  open: [notification: Notification]
  delete: [notification: Notification]
}>()

const { t } = useI18n()
</script>

<template>
  <DropdownMenuItem class="group items-start gap-3 py-2.5" @select="emit('open', notification)">
    <NotificationContent :notification="notification" />
    <!-- .stop keeps the row's @select (open + mark read) from firing as well. -->
    <button
      type="button"
      :aria-label="t('notifications.delete')"
      class="text-muted-foreground hover:text-foreground -mr-1 rounded-sm p-0.5 opacity-0 transition-opacity group-hover:opacity-100 group-focus:opacity-100"
      @click.stop="emit('delete', notification)"
      @keydown.enter.stop
    >
      <X class="size-3.5" />
    </button>
  </DropdownMenuItem>
</template>
